/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
import axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Button,
  Col,
  Label,
  Row,
  Table
} from 'reactstrap'
import ImageButtomNext from '../../assets/redemac/next.png'
import { FormFieldsModel } from '../../common/formFieldsModel'
import { ButtonType } from '../../common/global'
import ButtonWithImage from '../../components/Buttons/ButtonWithImage'
import GeneratorForm from '../../components/Generator/Generator'
import { CheckboxContainerRow, Input } from '../../components/Generator/styled'
import config from '../../config/request.config'
import { formatPhoneNumber } from '../../config/utils'
import { RolesContext } from '../../contexts/RolesContext'
import { addToSyncQueue, markRecordSynced, startAutoSync, syncPendingRecords } from '../../services/offlineSync'
import Roulette from '../roulette/Roulette'
import { CenteredContainer, CenteredContainer2, Container, Content, ContentForm, MessageFinal, OptionItemLabel, RadioButton, ReportContainer, ReportProps, TableCell, TableHeader, TableRow, Title, TitleDiv } from './styled'

// ─── Prize images mapping ─────────────────────────────────────────────────────
const PRIZE_IMAGES: Record<string, string> = {
  'Sab. Pom Pom': '/assets/softys/shampoo.png',
  'Sh. Pom Pom': '/assets/softys/sabonete.png',
  'Lenço Elite': '/assets/softys/lencos.png',
  'Totoka Babysec': '/assets/softys/totokinha.png',
  'Desconto 15%': '',
};

const loadQuantitiesFromLocalStorage = (): Record<string, number> => {
  const savedQuantities = localStorage.getItem('rouletteQuantities');
  return savedQuantities ? JSON.parse(savedQuantities) : {};
};

const Report: React.FC<ReportProps> = ({ data }) => {
  const [storedQuantities, setStoredQuantities] = useState<Record<string, number>>({});

  // Carregar quantidades do localStorage
  useEffect(() => {
    const quantities = loadQuantitiesFromLocalStorage();
    setStoredQuantities(quantities);
  }, []);

  if (!data || data.length === 0) {
    return <ReportContainer><Title>RELATÓRIO TOTAL</Title><p>Nenhum dado disponível</p></ReportContainer>;
  }

  return (
    <ReportContainer>
      <Title>RELATÓRIO</Title>
      <Table>
        <thead>
          <TableRow>
            <TableHeader>PRÊMIO</TableHeader>
            <TableHeader>ENTREGUES</TableHeader>
          </TableRow>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <TableRow key={index}>
              <TableCell>{item.prize_description}</TableCell>
              <TableCell>{item.total_quantity_used}</TableCell>
            </TableRow>
          ))}
        </tbody>
      </Table>

      {/* Exibindo os itens do ciclo atual */}
      <Title>CICLOS</Title>
      <Table>
        <thead>
          <TableRow>
            <TableHeader>PRÊMIO</TableHeader>
            <TableHeader>RESTANTES NO CICLO</TableHeader>
          </TableRow>
        </thead>
        <tbody>
          {Object.keys(storedQuantities).map((prize, index) => (
            <TableRow key={index}>
              <TableCell>{prize}</TableCell>
              <TableCell>{storedQuantities[prize]}</TableCell>
            </TableRow>
          ))}
        </tbody>
      </Table>
    </ReportContainer>
  );
};

type FormData = {
  [key: string]: any,
  quiz?: {
    [key: string]: any,
    idAnswer: string,
    right_answer_id?: string,
    order_question?: number,
    order_answer?: number
  }[]
};

const Login: React.FC = () => {
  const navigate = useNavigate();
  const roles = useContext(RolesContext);
  const [formData, setFormData] = useState<FormData>({});
  const [formErrors, setFormErrors] = useState({});
  const [avisoPrivacidadeView, setAvisoPrivacidadeView] = React.useState(false);
  const [activeTermsPrivacy, setActiveTermsPrivacy] = React.useState(false);
  const [fields, setFields] = React.useState<FormFieldsModel[]>([]);
  const [activeGeneratorForm, setActiveGeneratorForm] = React.useState<boolean>(false);
  const [finish, setFinish] = React.useState<boolean>(false);
  const [finish2, setFinish2] = React.useState<boolean>(true);
  const [newPrizeNumber, setNewPrizeNumber] = React.useState(-1);
  const [answerCount, setAnswerCount] = React.useState(0);
  const [mustSpin, setMustSpin] = useState(false);
  const [rouletteData, setRouletteData] = useState<any>([]);
  const [rouletteDataReports, setRouletteDataReports] = useState<any[]>([]);
  const [reports, setReports] = useState<any>(false);
  const [modules, setModule] = React.useState<number>(0);
  const [screenFinish, setScreenFinish] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [pageReady, setPageReady] = React.useState<boolean>(false);

  const generatorCode = () => { 
    // Obtenha a data e hora atual
    const now = new Date();

    // Gere um código numérico baseado na data/hora atual
    // Usando getTime(), que retorna o tempo em milissegundos desde 1970
    const codigo = now.getTime();

    // Converta o código para uma string para poder exibi-lo
    const codigoStr = codigo.toString();

    return Number(codigoStr)
  }

  const sendFormData = async (body: any): Promise<boolean> => {
    setLoading(true)
    const user = localStorage.getItem('isAuthenticated');

    const payload = {
      oxCustom: {
        lead: formData,
        user: String(user),
        code: String(generatorCode()),
        roulette: {
          prize: String(roles?.roles?.data_roulette[newPrizeNumber]?.option ?? ''),
          prize_number: newPrizeNumber,
        }
      }
    };

    // ── Salva localmente para garantia (modo offline-first) ──────────────────
    const queueId = addToSyncQueue(payload);

    // ── Tenta enviar ao servidor imediatamente se online ─────────────────────
    let sentDirectly = false;
    try {
      await axios.post(`${config.HOST}:${config.PORT}/v1/subscription`, payload, { timeout: 6000 });
      // Marca como sincronizado na fila para que syncPendingRecords não reenvie
      markRecordSynced(queueId);
      sentDirectly = true;
      console.log("Enviado ao servidor com sucesso.");
    } catch (err: any) {
      console.warn("Servidor indisponível – dado salvo offline.", err?.message);
    }

    // Dispara sync em background apenas para registros ainda pendentes (não o que já enviamos)
    if (!sentDirectly) {
      syncPendingRecords().then(({ synced }) => {
        if (synced > 0) console.log(`${synced} registro(s) sincronizado(s).`);
      });
    }

    localStorage.setItem('oxCustom', "");
    setFinish(false)
    setFinish2(true)
    setLoading(false)
    setNewPrizeNumber(-1);
    setFormData({});
    setAvisoPrivacidadeView(false);
    navigate('/presentation');
    return true;
  };

  const handleValidationFieldsMandatory = (): boolean => {
    let validation = true
    const subscriptions = roles?.roles?.subscription_modules?.modules[modules]?.subscriptions;
    if (subscriptions) {
      subscriptions.forEach((subscription) => {        
        if ((formData[subscription.name] === '' && subscription.mandatory) || (!(subscription.name in formData) && subscription.mandatory)) {
          validation = false
          // Aqui você pode adicionar o que você quer fazer quando uma subscrição obrigatória está vazia
          setFormErrors((prevData: any) => ({
            ...prevData,
            [subscription.name]: 'Preenchimento obrigatório!',
          }))
        }
      });
    }    
    console.log("subscriptions: ", subscriptions)
    console.log("formData: ", formData)
    console.log("formErrors: ", formErrors)
    return validation
  }

  const handleFormSubmitFinish = () => {

    if (!handleValidationFieldsMandatory()) return
    if (!avisoPrivacidadeView) {
      alert("Por favor aceite os termos antes de prosseguir!")
      return
    }
    setFinish(true)
  };

  const handleFormSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    const newFormErrors = {
      name: false,
      email: false,
      phone: false,
      profession: false,
    };

    if (!event.target) return;

    const form = event.target as HTMLFormElement;
    const nameInput = form.elements.namedItem('NOME:') as HTMLInputElement;
    const emailInput = form.elements.namedItem('E-MAIL:') as HTMLInputElement;
    const phoneInput = form.elements.namedItem('TELEFONE:') as HTMLInputElement;    
    const professionInput = form.elements.namedItem(
      'PROFISSÃO:'
    ) as HTMLInputElement;

    if (nameInput.value === '') {
      newFormErrors.name = true;
    }

    if (emailInput.value === '') {
      newFormErrors.email = true;
    }

    if (professionInput.value === '') {
      newFormErrors.profession = true;
    }

    if (phoneInput.value === '') {
      newFormErrors.phone = true;
    }

    // setFormErrors(newFormErrors);

    if (
      !newFormErrors.name &&
      // !newFormErrors.email &&
      !newFormErrors.profession &&
      !newFormErrors.phone
    ) {
      const formData = {
        name: nameInput.value,
        email: emailInput.value,
        phone: phoneInput.value,
        profession: professionInput.value,
      };

      // Aqui você pode fazer algo com o objeto formData, como salvar em um arquivo JSON ou enviar para um servidor
      console.log('Form Data:', formData);      
      localStorage.setItem('oxCustom', JSON.stringify(formData));
      // navigate('/presentation'); // Substitua '/dashboard' pela rota desejada
    }
  };

  // Adicione a função handleInputChange para tratar as mudanças nos campos do formulário
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | ButtonType, fieldFormat?: any[]) => {
    
    // Verifica se é do tipo ButtonType
    if ('id' in e && 'value' in e) {
      const { id, value } = e;

      let isBackspace = false;
      if (formData[id] && formData[id].length > value.length) {
        isBackspace = true;
      }

      let formattedValue = value;
      formattedValue = formattedValue.toUpperCase()

      // Se o campo atual é de formato telefone, ajusta o valor
      if (fieldFormat?.includes('numeric')) {
        formattedValue = formattedValue.replace(/[^0-9]/g, '');
      }

      // Se o campo atual é de formato telefone, ajusta o valor
      if (fieldFormat?.includes('phone')) {
        formattedValue = formatPhoneNumber(value, isBackspace)
        if (formattedValue.length === 1) formattedValue = ''
      }

      if (fieldFormat?.includes('email')) {
        formattedValue = formattedValue.toLowerCase()
      }

      if (fieldFormat?.includes('state')) {
        formattedValue = formattedValue.toUpperCase()
      }

      setFormData((prevData) => ({
        ...prevData,
        [id]: formattedValue || '',
      }));
      setFormErrors((prevData: any) => ({
        ...prevData,
        [id]: ''
      }));
    } 
    
    // Verifica se é um evento de mudança do React
    else if (e && "value" in e.target) {
      const { id, value } = e.target;

      let isBackspace = false;
      if (formData[id] && formData[id].length > value.length) {
        isBackspace = true;
      }

      let formattedValue = value;
      formattedValue = formattedValue.toUpperCase()

      // Se o campo atual é de formato telefone, ajusta o valor
      if (fieldFormat?.includes('numeric')) {
        formattedValue = formattedValue.replace(/[^0-9]/g, '');
      }

      // Se o campo atual é de formato telefone, ajusta o valor
      if (fieldFormat?.includes('phone')) {
        formattedValue = formatPhoneNumber(value, isBackspace)
        if (formattedValue.length === 1) formattedValue = ''
      }

      if (fieldFormat?.includes('email')) {
        formattedValue = formattedValue.toLowerCase()
      }

      if (fieldFormat?.includes('state')) {
        formattedValue = formattedValue.toUpperCase()
      }
 
      setFormData((prevData) => ({
        ...prevData,
        [id]: formattedValue || '',
      }));
      setFormErrors((prevData: any) => ({
        ...prevData,
        [id]: ''
      }));
    }
  };

  // Gera os grupos de campos
  const HandleGroupFields: React.FC = () => {
    const [selectedOption, setSelectedOption] = useState<string>('');

    const handleOptionChange = (group: string, fields: FormFieldsModel[]) => {
      setSelectedOption(group);      
      setFields(fields);
    };

    // Utilizamos o botão em vez de uma div com o evento onClick
    const handleStartButtonClick = () => {
      setActiveGeneratorForm(true);
    };

    return (
      <div style={{ textAlign: 'left' }}>
        <label style={{ fontSize: '2.8em' }}>Identificação:</label>
        <br />
        <br />
        <br />
        {roles?.roles?.subscription_group.map((group) => (
          <OptionItemLabel key={group.group_name} selected={selectedOption === group.group_name}>
            <RadioButton
              type="radio"
              name="option"
              value={group.group_name}
              checked={selectedOption === group.group_name}
              onChange={() => handleOptionChange(group.group_name, group.fields)}
            />
            {selectedOption === group.group_name ? '( ✓ )  ' : "( _ )  "}
            {group.group_name}            
          </OptionItemLabel>
        ))}      

        {/* Utilizamos o botão em vez de uma div com o evento onClick */}
        {selectedOption && (
          <ContentForm>
            <ButtonWithImage
              text="Iniciar"
              textColor="#071e5b"
              imageSrc={ImageButtomNext}
              fontSize="2.8em" 
              onClick={handleStartButtonClick} // Adicionamos o evento onClick aqui                  
            />
          </ContentForm>
        )}
      </div>
    );
  };

  const finishRoulette = () => {
    const rouletteDataToUse = rouletteData?.data_roulette ?? roles?.roles?.data_roulette;
    if (!rouletteDataToUse || newPrizeNumber === -1 || !rouletteDataToUse[newPrizeNumber]) {
      return <div style={{ color: 'white' }}>SEM INFORMAÇÕES</div>;
    }

    const prizeOption: string = String(rouletteDataToUse[newPrizeNumber].option);
    const prizeImage: string = PRIZE_IMAGES[prizeOption] ?? '';

    return (
      <MessageFinal>
        <div
          style={{
            width: '100%',
            minHeight: '100vh',
            backgroundColor: '#5b9bd5',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            cursor: 'pointer',
            padding: '60px 40px',
            boxSizing: 'border-box',
          }}
          onClick={() => {
            setMustSpin(false);
            setFinish(true);
            setFinish2(false);
          }}
        >
          {/* Logo Softys */}
          <img src="/assets/softys/logo_softys.png" alt="Softys" style={{ maxWidth: '520px', width: '65%', marginBottom: '40px', objectFit: 'contain' }} />

          <div style={{
            color: '#FFFFFF',
            fontSize: '110px',
            fontWeight: 'bold',
            textAlign: 'center',
            lineHeight: 1.1,
            marginBottom: '16px',
          }}>
            Parabéns!
          </div>

          <div style={{
            color: '#93D4DE',
            fontSize: '80px',
            fontWeight: 'bold',
            textAlign: 'center',
            lineHeight: 1.3,
            marginBottom: '40px',
          }}>
            Você ganhou<br />{prizeOption}!
          </div>

          {prizeImage ? (
            <img
              src={prizeImage}
              alt={prizeOption}
              style={{
                maxWidth: '860px',
                maxHeight: '680px',
                objectFit: 'contain',
                marginBottom: '20px',
              }}
            />
          ) : (
            <div style={{
              width: '800px',
              height: '280px',
              backgroundColor: '#5286BF',
              borderRadius: '32px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '100px',
              fontWeight: 'bold',
              color: '#FFFFFF',
              textAlign: 'center',
              padding: '40px',
              marginBottom: '100px',
            }}>
              15% OFF
            </div>
          )}

          <div className="text-pulse" style={{
            color: '#93D4DE',
            fontSize: '52px',
            textAlign: 'center',
            marginTop: '10px',
          }}>
            Toque para continuar
          </div>
        </div>
      </MessageFinal>
    );
  };

  const generatePrizesRoulette = async () => {
    try {
      // Always pass all 8 slots to the Roulette component.
      // The Roulette handles slot-based quantity tracking and order internally.
      setRouletteData(roles?.roles || [])
    } catch (error) {	
      console.log('Error:', error);
    }
  }

  // Função para obter a data de hoje no formato DD/MM
  function getTodayDate() {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Mês começa em 0
    return `${day}/${month}`;
  }

  useEffect(() => {
    // Inicia sincronização automática em background
    startAutoSync(30000);
  }, []);

  useEffect(() => {
    generatePrizesRoulette()
  }, [roles]);

  // Aguarda roles carregarem antes de revelar a tela
  useEffect(() => {
    if (roles?.roles) {
      const t = setTimeout(() => setPageReady(true), 120);
      return () => clearTimeout(t);
    }
  }, [roles]);

  // Auto-advance: if on thank-you screen and no interaction for 30s, go to /presentation
  useEffect(() => {
    const isThankYouScreen = screenFinish || (finish && !finish2);
    if (!isThankYouScreen) return;

    const timer = setTimeout(() => {
      sendFormData(formData);
    }, 30000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screenFinish, finish, finish2]);

  // useEffect(() => {
  //   console.log("formData" , formData)
  // }, [])

  return (
    <>
      <Container className={pageReady ? 'register-reveal register-visible' : 'register-reveal'} color={roles?.roles?.background_color}>
        {
          screenFinish ? (
            <div
              style={{
                width: '100%', minHeight: '100vh', backgroundColor: '#5b9bd5',
                display: 'flex', flexDirection: 'column', alignItems: 'center',
                justifyContent: 'flex-start', cursor: 'pointer',
                paddingTop: '120px', boxSizing: 'border-box',
              }}
              onClick={() => sendFormData(formData)}
            >
              <img src="/assets/softys/logo_softys.png" alt="Softys" style={{ maxWidth: '780px', width: '85%', marginBottom: '120px', objectFit: 'contain' }} />
              <div style={{ color: '#FFFFFF', fontSize: '86px', fontWeight: 'bold', textAlign: 'center', lineHeight: 1.3 }}>Softys agradece a sua participação!</div>
              <div className="text-pulse" style={{ color: '#FFFFFF', fontSize: '64px', textAlign: 'center', marginTop: '100px', opacity: 0.7 }}>Toque para encerrar</div>
            </div>
          ) :
          activeTermsPrivacy ? (
            <Content>
              <img
                src="/assets/softys/logo_softys.png"
                alt="Softys"
                style={{ maxWidth: '480px', width: '68%', marginBottom: '44px', objectFit: 'contain' }}
              />
              <TitleDiv>
                {roles?.roles?.lgpd}
              </TitleDiv>
              <div style={{ display: 'flex', gap: '40px', marginTop: '60px', width: '90%', maxWidth: '900px' }}>
                <Button
                  style={{
                    flex: 1,
                    height: '120px',
                    fontSize: '46px',
                    fontWeight: 'bold',
                    border: 'none',
                    borderRadius: '12px',
                    backgroundColor: '#062f6e',
                    color: '#FFFFFF',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setAvisoPrivacidadeView(true);
                    setActiveTermsPrivacy(false);
                  }}
                >
                  CONCORDO
                </Button>
                <Button
                  style={{
                    flex: 1,
                    height: '120px',
                    fontSize: '46px',
                    fontWeight: 'bold',
                    border: 'none',
                    borderRadius: '12px',
                    backgroundColor: '#5286BF',
                    color: '#FFFFFF',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setAvisoPrivacidadeView(false);
                    setActiveTermsPrivacy(false);
                  }}
                >
                  DISCORDO
                </Button>
              </div>
            </Content>)
            : reports ? (
              <div onClick={() => setReports(false)}>
                <Report data={rouletteDataReports} />
                <Button
                   onClick={() => setReports(false)}
                  style={{
                    width: '100%',
                    height: '70px',
                    fontSize: '22px',
                    borderRadius: '20px',
                    backgroundColor: roles?.roles?.styles?.buttons_color_background || 'white',
                    color: roles?.roles?.styles?.buttons_color_text,
                    marginTop: '15px'
                  }}>VOLTAR</Button>
              </div>
            )
            : finish && newPrizeNumber !== -1 && finish2 ? (
              <CenteredContainer2>
                {/* <Logo src={Logo1} alt="Logo" style={{ marginTop: '100px' }} /> */}
                {finishRoulette()}
              </CenteredContainer2>)
              : finish && finish2 && roles?.roles?.roulette_active ? (
                <CenteredContainer className="page-enter">
                  {/* ── Logo fixa no topo ─────────────────────────────────── */}
                  <img
                    src="/assets/softys/logo_softys.png"
                    alt="Softys"
                    style={{
                      position: 'fixed', top: '38px', left: '50%',
                      transform: 'translateX(-50%)',
                      maxWidth: '400px', width: '48%',
                      objectFit: 'contain', zIndex: 10,
                      filter: 'drop-shadow(0 4px 18px rgba(0,0,0,0.38))',
                    }}
                  />
                  {/* ── Halo de fundo animado ─────────────────────────────── */}
                  <div className="roulette-bg-glow" />
                  {/* ── Estrelas flutuantes ───────────────────────────────── */}
                  <span className="roulette-star" style={{ left: '7%',  bottom: 0, '--dur': '6.2s', '--delay': '0s'   } as any}>★</span>
                  <span className="roulette-star" style={{ left: '17%', bottom: 0, '--dur': '7.8s', '--delay': '1.6s' } as any}>✦</span>
                  <span className="roulette-star" style={{ left: '32%', bottom: 0, '--dur': '6.5s', '--delay': '3.1s' } as any}>⭐</span>
                  <span className="roulette-star" style={{ left: '62%', bottom: 0, '--dur': '7.1s', '--delay': '0.5s' } as any}>★</span>
                  <span className="roulette-star" style={{ left: '76%', bottom: 0, '--dur': '5.9s', '--delay': '2.3s' } as any}>✦</span>
                  <span className="roulette-star" style={{ left: '88%', bottom: 0, '--dur': '8.2s', '--delay': '4.0s' } as any}>⭐</span>
                  {/* ── Roda da fortuna ───────────────────────────────────── */}
                  <Roulette data={rouletteData} setNewPrizeNumber={setNewPrizeNumber} answerCount={answerCount} mustSpin={mustSpin} setMustSpin={setMustSpin} />
                  {/* ── Botão GIRAR ───────────────────────────────────────── */}
                  {!roles?.roles?.styles?.buttons_image_active ? (
                    <button
                      className="roulette-girar-btn"
                      onClick={() => setMustSpin(true)}
                      disabled={mustSpin}
                    >
                      {roles?.roles?.subscription_config?.label_next}
                    </button>
                  ) : (
                    <ButtonWithImage
                      text="Avançar"
                      textColor="#071e5b"
                      imageSrc={ImageButtomNext}
                      fontSize="2.8em"                    
                    />  
                  )}
                  <div onClick={() => setReports(true)} style={{ width: '400px', height: '250px', position: 'fixed', top: '50px' }}></div>    
                </CenteredContainer>
            ) : 
          finish && !finish2 ? (
            <div
              style={{
                width: '100%',
                minHeight: '100vh',
                backgroundColor: '#5b9bd5',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'flex-start',
                cursor: 'pointer',
                paddingTop: '120px',
                boxSizing: 'border-box',
              }}
              onClick={() => {
                sendFormData(formData);
              }}
            >
              <img src="/assets/softys/logo_softys.png" alt="Softys" style={{ maxWidth: '780px', width: '85%', marginBottom: '120px', objectFit: 'contain' }} />
              <div style={{
                color: '#FFFFFF',
                fontSize: '86px',
                fontWeight: 'bold',
                textAlign: 'center',
                lineHeight: 1.3,
                marginBottom: '40px',
              }}>
                Softys agradece a sua participação!
              </div>
              <div className="text-pulse" style={{
                color: '#FFFFFF',
                fontSize: '64px',
                textAlign: 'center',
                opacity: 0.8,
                marginTop: '100px',
              }}>
                Toque para encerrar
              </div>
            </div>
          ) :
              <Content>
                <div style={{ height: '20px' }} onClick={() => setReports(true)} />
                <img
                  src="/assets/softys/logo_softys.png"
                  alt="Softys"
                  style={{ maxWidth: '520px', width: '72%', marginBottom: '50px', objectFit: 'contain' }}
                />
                <ContentForm>
                  {roles?.roles?.group_active ? (
                    <>
                        {activeGeneratorForm ? <>
                          <GeneratorForm // Utilize o GeneratorForm aqui
                            fields={fields}
                            formData={formData}
                            formErrors={formErrors}
                            handleInputChange={handleInputChange}
                            handleFormSubmit={handleFormSubmit}
                            setFormErrors={setFormErrors}    
                          />
                          <ContentForm onClick={() => setFinish(true)}>
                            {!roles?.roles?.styles?.buttons_image_active ? (
                              <Button
                                style={{
                                  width: '100%',
                                  height: '70px',
                                  fontSize: '22px',
                                  borderRadius: '20px',
                                  backgroundColor: roles?.roles?.styles?.buttons_color_background || 'white',
                                  color: roles?.roles?.styles?.buttons_color_text,
                                  marginTop: '15px'
                                }}>PROSSIGA</Button>
                            ) : (
                              <ButtonWithImage
                                text="Avançar"
                                textColor="#071e5b"
                                imageSrc={ImageButtomNext}
                                fontSize="2.8em"                    
                              />  
                            )}
                          </ContentForm>
                        </> : <HandleGroupFields />}
                    </>
                  ) : <>
                        <GeneratorForm
                          fields={roles?.roles?.subscription_modules.modules[modules].subscriptions || []}
                          formData={formData}
                          formErrors={formErrors}
                          handleInputChange={handleInputChange}
                          handleFormSubmit={handleFormSubmit}
                          setFormErrors={setFormErrors}    
                              />
                              {roles?.roles?.subscription_modules.modules[modules].config.lgpd && (
                                <div style={{ textAlign: 'left', marginTop: '50px' }}>
                                  {/* {roles?.roles?.lgpd} */}
                                  <CheckboxContainerRow>
                                    <Input
                                      type="checkbox"
                                      id={'lgpd'}
                                      checked={avisoPrivacidadeView}
                                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
                                        setAvisoPrivacidadeView(e.target.checked)  // Atualize o estado com o novo valor
                                      }
                                      style={{ width: '72px', height: '72px', marginRight: '0', marginLeft: '-2px' }} // Ajuste o tamanho conforme necessário
                                    />
                                    <Label color="black" style={{ textAlign: 'left', fontSize: '38px', marginTop: '0', marginLeft: '20px' }}>
                                      Concordo com a LGPD. <a href="#" style={{ textDecoration: "underline"}} onClick={() => setActiveTermsPrivacy(true)}>Ler mais</a>
                                    </Label>                                    
                                  </CheckboxContainerRow>
                                </div>
                              )}
                        <ContentForm onClick={() => handleFormSubmitFinish()}>
                          {!roles?.roles?.styles?.buttons_image_active ? (
                            <Button
                              style={{
                                width: '60%',
                                height: '140px',
                                fontSize: '52px',
                                borderRadius: '12px',
                                backgroundColor: roles?.roles?.styles?.buttons_color_background || 'white',
                                color: roles?.roles?.styles?.buttons_color_text,
                                marginTop: '15%'
                              }}>PROSSIGA</Button>
                          ) : (
                            <ButtonWithImage
                              text="Avançar"
                              textColor="#071e5b"
                              imageSrc={ImageButtomNext}
                              fontSize="2.8em"                    
                            />  
                          )}                          
                        </ContentForm>
                    </>}       
                </ContentForm>                  
              </Content>  
        }
            
      </Container>      
    </>
  );
};

export default Login;
